import Vue from "vue";
import Storage from "@/utils/storage";
import FollowService from "@/services/FollowService";

//default state
const initialState = () => ({
});
const state = initialState();

const getters = {};

const mutations = {};

const actions = {
  async getFollow({ commit, state }, page = 1) {
    let follow = await FollowService.getFollow(page);
    return follow
  },
  async setFollow({ commit, state }, data) {
    let input = {
      entityId: data.id,
      entityName: data.address ? "course" : "user",
    };
    let res = await FollowService.setFollow(input);
    if (res.error) {
      return res;
    } else {
      return true;
    }
  },
  async setUnFollow({ commit, dispatch }, data) {
    let res = await FollowService.setUnFollow(data);
    if (res) {
      console.log(res);
      return res;
    } else {
      return true;
    }
  },
  async getFollowUser({ commit, state }, data) {
    let { page, limit, userId } = data;
    let follow = await FollowService.getFollowByUser(userId)
    return follow
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
